import axios from 'axios'

let S3Upload = require('../app/upload_s3')
const CancelToken = axios.CancelToken
let cancel

export const s3UploadMixin = {
  data () {
    return {
      s3uploads: [],
      assets: [],
      saving: false
    }
  },

  methods: {
    getFiles () {
      return this.files
    },
    getFileInput () {
      return this.$refs.fileInput
    },
    preSubmit () {
      this.$v.$touch()
    },
    postSubmit () {
      this.assets = []
      this.s3uploads = []
    },
    isValidForm () {
      let files = this.getFiles()
      for (const i in files) {
        let nameLength = files[i].name.length
        if (nameLength > 120) {
          this.$store.commit('setCustomErrorMsg', 'Nombre del archivo demasiado largo.')
          return false
        }
      }
      return !this.$v.$invalid
    },
    uploadAllFiles (event) {
      let files = this.getFiles()
      this.preSubmit()
      if (this.isValidForm()) {
        this.saving = true
        let cancelToken = new CancelToken(function executor (c) {
          cancel = c
        })
        if (files.length > 0) {
          for (const i in files) {
            this.uploadFile(files[i], cancelToken)
          }
        } else {
          this.submit()
        }
      }
    },
    handleError () {
      this.$store.commit('setCustomErrorMsg', 'Se produjo un error al realizar el upload, por favor reintente.')
      this.s3uploads = []
      this.assets = []
      this.getFileInput().cleanProgress()
      this.saving = false
    },
    prepareUpload (currentFile, cancelToken) {
      const options = {
        /* eslint-enable */
        onProgressChanged: (fileName, totalProgress) => {
          this.getFileInput().updateProgressFor(fileName, totalProgress)
        },
        onUploadCompleted: (asset) => {
          this.assets.push(asset)
          if (this.assets.length === this.s3uploads.length) {
            this.submit()
          }
        },
        onServerError: (error) => {
          if (error) {
            cancel()
            this.handleError()
          }
        },
        onS3Error: (error) => {
          if (error) {
            this.handleError()
          }
        }
      }

      let currentUpload = new S3Upload.S3Upload(currentFile, options, cancelToken)
      this.s3uploads.push(currentUpload)
      return currentUpload
    },
    uploadFile (currentFile, cancelToken) {
      let currentUpload = this.prepareUpload(currentFile, cancelToken)
      currentUpload.signS3()
    }
  }
}
